export default "__VITE_ASSET__pTw0Ov4B__"